$(function() {
  $.ajax({
    // url: 'https://cdn.shopify.com/s/files/1/0275/8420/0792/files/storesColombia_1_8feb14bf-94a6-4c26-8411.csv?v=1775855933',
    // url: 'https://cdn.shopify.com/s/files/1/0275/8420/0792/files/storesColombia_2_86a0386e-74b5-49cc-adf3-875b26b18e34.csv?v=1782312260',
    // url: 'https://cdn.shopify.com/s/files/1/0275/8420/0792/files/storesColombia_2_86a0386e-74b5-49cc-adf3-875b26b18e36.csv?v=1784068312',
    // url: 'https://cdn.shopify.com/s/files/1/0275/8420/0792/files/storesColombia_2_86a0386e-74b5-49cc-adf3-875b26b18e36_1.csv?v=1785361549',
    // url: 'https://cdn.shopify.com/s/files/1/0275/8420/0792/files/storesColombia_2_86a0386e-74b5-49cc-adf3-875b26b18e36_1777.csv?v=1787078845',
    url: 'https://cdn.shopify.com/s/files/1/0275/8420/0792/files/storesColombia_2_1777_1_97ba4f60-87e4-41b0-ab1d-1cbfc4829db0.csv?v=1787937517',
    dataType: 'text',          
    scriptCharset: "UTF-8",
  }).done(getStore);
});

var array = [], lng = 4.60971, lat = -74.08175;
var map_store,infoWindows_store,marker_store,geoconder_store, state_store = 0;
var Latlng;

function getStore(data) {
  var country = 'Colombia';
  var city, name_store, state = 0, html;
  
  if(country != null){
    
    var allRows = data.split(/\r?\n|\r/);
    
    for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
      
      var rowCells = allRows[singleRow].split(';');
      console.log(rowCells);
      if(rowCells[0] != null && rowCells[7] != undefined){
        
        if((rowCells[7] == country || quitarAcentos(rowCells[7].toUpperCase()) == quitarAcentos(country.toUpperCase()))){
          
          
          var name_final = rowCells[4];
          
          if(array.length == 0){
            
            var a = {
              city: name_final, 
              data: []
            }

            console.log(rowCells[0])
            console.log(rowCells[1])
            console.log(rowCells[2])
            console.log(rowCells[3])
            console.log(rowCells[4])
            console.log(rowCells[5])
            console.log(rowCells[6])
            console.log(rowCells[7])
            console.log(rowCells[8])
            console.log(rowCells[9])
            console.log(rowCells[10])
            console.log(rowCells[11])
            
            var data = {
              name: rowCells[0],
              mobile: rowCells[1] + ' ' + rowCells[11],
              email: rowCells[2],
              direction: rowCells[3],
              lat: rowCells[5],
              lng: rowCells[6],
              lv: rowCells[8],
              service: rowCells[9],
              img: rowCells[10]
            }

            
            
            a['data'].push(data);

            console.log(a);
            
            array.push(a);
            
          }else{
            
            state = 0;
            
            for (var singleRow2 = 0; singleRow2 < array.length; singleRow2++) {
              if(name_final == array[singleRow2]['city']){
                
                var data = {
                  name: rowCells[0],
                  mobile: rowCells[1] + ' ' + rowCells[11],
                  email: rowCells[2],
                  direction: rowCells[3],
                  lat: rowCells[5],
                  lng: rowCells[6],
                  lv: rowCells[8],
                  service: rowCells[9],
                  img: rowCells[10]
                }
                
                array[singleRow2]['data'].push(data);
                state = 1;
              }
             }
            
             if(state == 0){
               
                var a = {
                  city: name_final, 
                  data: []
                }
                
                var data = {
                    name: rowCells[0],
                    mobile: rowCells[1] + ' ' + rowCells[11],
                    email: rowCells[2],
                    direction: rowCells[3],
                    lat: rowCells[5],
                    lng: rowCells[6],
                    lv: rowCells[8],
                    service: rowCells[9],
                    img: rowCells[10]
                  }
                
                a['data'].push(data);
                
               array.push(a);
             }
           }
         }
       }
    }
    
   for (var singleRow = 0; singleRow < array.length; singleRow++) {
     
     var name_store = "<ul class='dropdown-menu dropdown-menu-right'>";
          
     city = "<div class='dropdown'><button id='"+ singleRow +"' class='drop-tiendas btn-tiendas dropdown-toggle' type='button' data-toggle='dropdown'>"+ array[singleRow]['city'] +"<span class='caret'></span></button>";
     
     for (var singleRow2 = 0; singleRow2 < array[singleRow]['data'].length; singleRow2++) {
       
       	 name_store = name_store + "<li id='" + singleRow2 +"'><a>" + array[singleRow]['data'][singleRow2]['name'] + "</a></li>";
       	
   	  }
     
     if(singleRow == 0){
     	html = city + name_store + "</ul></div>";
     }else{
      html = html + city + name_store + "</ul></div>"; 
     }
     
    }
    
    $("#list_store").html(html);
    
    $('#title-store').html(array[0]['data'][3]['name']);
    $('#direction-store').html('<li>' + array[0]['data'][3]['direction'] + '</li>');
    $('#email-store').html('<li>' + array[0]['data'][3]['email'] + '</li>');
     
    if(array[0]['data'][3]['mobile'] != ' '){
    	$('#mobile-store').html('<li>' + array[0]['data'][3]['mobile'] + '</li>');
    }
    
    if(array[0]['data'][3]['service'] != ' '){
    	$('#service-store').html('<li>' + array[0]['data'][3]['service'] + '</li>');
    }
    
    $('#lv-store').html('<li>' + array[0]['data'][3]['lv'] + '</li>');
    
    $('#img-store').html('<img class="img-tiendas" src="'+ array[0]['data'][3]['img'] +'">');
    
    lat = parseFloat(array[0]['data'][3]['lat']);
    lng = parseFloat(array[0]['data'][3]['lng']);

    console.log(lat)
    console.log(lng)
    
    Latlng = new google.maps.LatLng(lat,lng);
    marker_store.setPosition(Latlng);
  	marker_store.setVisible(true);
    
    var center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };
        
    map_store.setCenter(center);
   
  }
}


$(document).ready(function(){
  
  	$('body').on('click', '#list_store li', function(){
     
      
      $('#title-store').html(array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['name']);
      $('#direction-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['direction'] + '</li>');
      $('#email-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['email'] + '</li>');
      
      if(array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['mobile'] != ' '){
        $('#mobile-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['mobile'] + '</li>');
      }
      
      $('#lv-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['lv'] + '</li>');
      
      if(array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['service'] != ' '){
        $('#service-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['service'] + '</li>');
      }
      
      $('#img-store').html('<img class="img-tiendas" src="'+ array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['img'] +'">');
      
      
      /*$('html, body').animate({
       scrollTop: $("#map-store").offset().top
       }, 1000);*/

      lat = array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['lat'];
      lng = array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['lng'];


      Latlng = new google.maps.LatLng(parseFloat(lat),parseFloat(lng));
      marker_store.setPosition(Latlng);
      marker_store.setVisible(true);

        var center = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };

      map_store.setCenter(center);
    
  	});
});


function quitarAcentos(cadena){
	const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
	return cadena.split('').map( letra => acentos[letra] || letra).join('').toString();	
}

function capitalize(s){
  var s = s.toLowerCase(); 
  return s.charAt(0).toUpperCase() + s.slice(1);
}
          
function initMap() {
  geocoder_store = new google.maps.Geocoder();
  map_store = new google.maps.Map(document.getElementById("map-store"), {
    center: {
      lat: lat,
      lng: lng
    },
    zoom: 12
  });

  console.log(lat)
  console.log(lng)
  Latlng = new google.maps.LatLng(lat,lng);
  console.log(Latlng)

  infoWindows_store = new google.maps.InfoWindow();
  marker_store = new google.maps.Marker({
    map: map_store,
    anchorPoint: new google.maps.Point(0, -29)
  });

  marker_store.setPosition(Latlng);
  marker_store.setVisible(true);
}

window.initMap = initMap;
